import styled from 'styled-components'

export const Grid = styled.div`
  display: flex;
  flex-direction: column;
`

export const ScrollerAreaStart = styled.div`
  scroll-snap-align: start;
`

export const ScrollerAreaEnd = styled.div`
  scroll-snap-align: end;
`
